export const catalog_matrix = [
  {form_key:'product_id', catalog_key:'products'},
  {form_key:'diagnosis_id', catalog_key:'diagnostics'},
  {form_key:'hospital_id', catalog_key:'hospitals'},
  {form_key:'adjuvant', catalog_key:'adjuvants'},
  
  //{form_key:'responsible_id', catalog_key:'none', propname:'users'},
]